/*
 * Tab content registry.
 *
 * Maps moduleName → tabKey → Component rendered below the header.
 * The 'details' tab always uses the default DetailViewV1 layout — never register it here.
 *
 * To add content for a new module/tab:
 *   1. Import the component.
 *   2. Add an entry: REGISTRY[moduleName][tabKey] = ({ id, ...rest }) => <YourTab ... />.
 *
 * Props passed to every registered component: { id, moduleName, onDescriptionSaved }
 */

const REGISTRY = {
  // Add future modules here:
  // candidate: { jobs: ({ id }) => <CandidateJobsTab candidateId={id} /> },
};

// Returns the effective registry: built-in entries merged with whatever the host
// injected via configureCoreTheme({ tabContentRegistry: { job: { candidates: fn } } }).
// Host entries WIN per tab key, so a consumer can replace any built-in tab renderer.
// Called at render time so configs set in main.jsx are always picked up.
function getEffectiveRegistry() {
  const host =
    (typeof window !== 'undefined' && window.__CORE_THEME_CONFIG__?.tabContentRegistry) ?? {};
  if (!Object.keys(host).length) return REGISTRY;
  const merged = { ...REGISTRY };
  Object.entries(host).forEach(([mod, tabs]) => {
    merged[mod] = { ...(merged[mod] ?? {}), ...tabs };
  });
  return merged;
}

export function getTabContent(moduleName, tabKey) {
  if (!tabKey || tabKey === 'details') return null;
  return getEffectiveRegistry()[moduleName]?.[tabKey] ?? null;
}
